import Vue from 'vue';

import Default from '@/layouts/Default.vue';
import FullHeight from '@/layouts/FullHeight.vue';


Vue.component("default-layout", Default);
Vue.component("full-height-layout", FullHeight);